import { render, staticRenderFns } from "./CustomerCustomInfoList.vue?vue&type=template&id=32da7cc0&scoped=true"
import script from "./CustomerCustomInfoList.vue?vue&type=script&lang=js"
export * from "./CustomerCustomInfoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32da7cc0",
  null
  
)

export default component.exports